import {useQuery} from 'react-query';
import {getStoreView} from '../../../../services/shop/dashboard';
import {useAuth} from '../../../../context/authContext';

const UseGetActivityPanel = () => {
  const {supplierProfile} = useAuth();
  const {data: activityReport, isLoading} = useQuery(
    ['storeView', supplierProfile?.guid],
    getStoreView,
    {staleTime: 50000},
  );

  return {activityReport, isLoading};
};

export default UseGetActivityPanel;
